exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.accessibility-font {\n  font-size: 1.25em;\n  font-size: 1.25rem;\n}\n.accessibility-greyscale {\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n  filter: grayscale(100%);\n  min-height: 100vh;\n}\n.accessibility-contrast {\n  -webkit-filter: invert(100%);\n  -moz-filter: invert(100%);\n  filter: invert(100%);\n  min-height: 100vh;\n}\n.accessibility-highlight-link {\n  padding: 3px;\n  background-color: black !important;\n  color: yellow !important;\n  text-decoration: underline !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./node_modules/vue-accessibility-toolbar/src/AccessibilityToolbar.vue
// module id = tGH8
// module chunks = 70